const BULK_DOWNLOAD_BATCH_SIZE = 10000;
const PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 50];
const DETAIL_PANEL_POSITIONS = {
  RIGHT: "right",
  TOP: "top",
};


export {  BULK_DOWNLOAD_BATCH_SIZE,
  PAGE_SIZE_OPTIONS,
  DETAIL_PANEL_POSITIONS,
};